if (document.getElementById('form-relato')) {   

    const form_relato = document.getElementById('form-relato');
    const dropZone = document.getElementById('dropZone');
    const fileInput = document.getElementById('fileInput');
    const fileList = document.getElementById('fileList');
    let selectedFiles = [];

    dropZone.addEventListener('click', () => {
        fileInput.click();
    });

    dropZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropZone.classList.add('dragover');
    });

    dropZone.addEventListener('dragleave', () => {
        dropZone.classList.remove('dragover');
    });

    dropZone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropZone.classList.remove('dragover');
        const files = Array.from(e.dataTransfer.files);
        handleFiles(files);
    });

    fileInput.addEventListener('change', (e) => {
        const files = Array.from(e.target.files);
        handleFiles(files);
    });

    function handleFiles(files) {
        files.forEach(file => {
            if (!selectedFiles.includes(file)) {
                selectedFiles.push(file);

                const listItem = document.createElement('li');
                listItem.textContent = file.name;

                const removeButton = document.createElement('button');
                removeButton.textContent = 'Remover';
                removeButton.classList.add('remove-button');
                removeButton.addEventListener('click', () => {
                    const index = selectedFiles.indexOf(file);
                    if (index > -1) {
                        selectedFiles.splice(index, 1);
                    }
                    fileList.removeChild(listItem);
                    updateFileInput();
                });

                listItem.appendChild(removeButton);
                fileList.appendChild(listItem);
            }
        });

        updateFileInput();
    }

    function updateFileInput() {
        const dataTransfer = new DataTransfer();
        selectedFiles.forEach(file => {
            dataTransfer.items.add(file);
        });
        fileInput.files = dataTransfer.files;
    }

    let seconds = 5;
    function countdown() {
        var timer = document.getElementById('timer');
        if (seconds > 0) {
            timer.textContent = seconds; seconds--;
            setTimeout(countdown, 1000);
        }
        else if (seconds == 0) {
            timer.innerHTML = "<span class='fs-5'>Redirecionando...</span>"; seconds--;
            setTimeout(countdown, 1000);
        }
        else {
            timer.innerHTML = "<span class='fs-6 fw-normal'>Caso não tenha sido redirecionado, <a href='https://rodoviariadebelohorizonte.com.br/fale-conosco/'>clique aqui</a>.</span>";
            window.location.href = "https://rodoviariadebelohorizonte.com.br/fale-conosco/";
        }
    }

    function check_relato_anonimo($this) {
        const grupo_identificacao = document.getElementById('grupo-identificacao');
        if ($this.checked) {
            grupo_identificacao.setAttribute('disabled', true);
        } else {
            grupo_identificacao.removeAttribute('disabled');
        }
    }
    const check_anonimo = document.getElementById('input-anonimo');
    check_relato_anonimo(check_anonimo);

    function check_relato_aceite($this) {
        const grupo_relado = document.getElementById('grupo-relato');
        if ($this.checked) {
            grupo_relado.style.display = 'block';
        } else {
            grupo_relado.style.display = 'none';
        }
    }
    const check_aceite = document.getElementById('input-aceite');
    check_relato_anonimo(check_aceite);

    function select_relacionamento($value) {

        const relacionamento_outros = document.getElementById('relacionamento-outros');
        const input_relacionamento_outros = document.getElementById('input-relacionamento-outros');

        if ($value == 'SAC') {
            countdown();
            document.getElementById('redirect').style.display = 'flex';
        }
        else if ($value == 'Outros') {
            relacionamento_outros.style.display = 'block';
            relacionamento_outros.focus();
            input_relacionamento_outros.setAttribute('required', true);
        }
        else {
            relacionamento_outros.style.display = 'none';
            input_relacionamento_outros.removeAttribute('required');
        }
    }
    const input_relacionamento = document.getElementById('input-relacionamento');
    select_relacionamento(input_relacionamento.value);

    function select_topico($value) {
        if ($value == 'SAC') {
            countdown();
            document.getElementById('redirect').style.display = 'flex';
        }
    }
    const input_topico = document.getElementById('input-topico');
    select_topico(input_topico.value);

    function select_dano_financeiro($value) {
        const dano_financeiro_valor = document.getElementById('relato-dano-financeiro-valor');
        const input_dano_financeiro_valor = document.getElementById('input-relato-dano-financeiro-valor');

        if ($value == 'Sim') {
            dano_financeiro_valor.style.display = 'block';
            dano_financeiro_valor.focus();
            input_dano_financeiro_valor.setAttribute('required', true);
        } else {
            dano_financeiro_valor.style.display = 'none';
            input_dano_financeiro_valor.removeAttribute('required');
        }
    }
    const input_dano_financeiro = document.getElementById('input-relato-dano-financeiro');
    select_dano_financeiro(input_dano_financeiro.value);

    function select_informou_outro($value) {
        const outro_informado = document.getElementById('relato-outro-informado');
        const input_outro_informado = document.getElementById('input-relato-outro-informado');
        if ($value == 'Sim') {
            outro_informado.style.display = 'block';
            outro_informado.focus();
            input_outro_informado.setAttribute('required', true);
        } else {
            outro_informado.style.display = 'none';
            input_outro_informado.removeAttribute('required');
        }
    }
    const input_informou_outro = document.getElementById('input-relato-informou-outro');
    select_informou_outro(input_informou_outro.value);

    form_relato.addEventListener('submit', function () {
        document.getElementById('loading').style.display = 'flex';
    });

}

if (document.getElementById('print-relato')) {
    function printRelato() {
        var divToPrint = document.getElementById('print-relato');
        var newWin = window.open('', 'Print-Window');

        newWin.document.open();
        newWin.document.write('<html><head><title>Imprimir Relato</title>');
        newWin.document.write('<link href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap" rel="stylesheet">');
        newWin.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">');
        newWin.document.write('<link rel="stylesheet" href="/assets/css/styles.min.css">');
        newWin.document.write('</head><body onload="window.print()">');
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.write('</body></html>');
        newWin.document.close();

        setTimeout(function () {
            newWin.close();
        }, 10);
    }
}